import SilentModeration, { SilentHistory, SilentStatus } from '../SilentModeration';
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import { Button, message, Popconfirm } from 'antd';
import { Query, withApollo } from 'react-apollo';
import { GET_MESSAGE_DETAIL } from '../../api/message';
import { GET_CURRENT_USER } from '../../api/user';
import { DELETE_COM } from '../../api/comment';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading';
import UserDetail from '../UserDetail';
import ModalBox from '../ModalBox';
import './index.css';

// Same per-post order and Excel-style suffixes as the app's forum detail.
function anonymousSuffix(position) {
  let suffix = '';
  for (let number = position; number > 0; number = Math.floor((number - 1) / 26)) {
    suffix = String.fromCharCode(65 + (number - 1) % 26) + suffix;
  }
  return suffix;
}

function EvidenceProfile({ profile }) {
  if (!profile) return null;
  return (
    <div className="detail-evidence-profile">
      <img src={profile.avatarUrl} alt="" />
      <div>
        <div>{profile.nickname || '未设置昵称'}</div>
        <code>UID {profile._id}</code>
      </div>
    </div>
  );
}

function messageDetail({ client, _id, onViewUserHistory }) {
  if (!_id) return null;
  const [showUserModal, toggleUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [showProfileInEvidence, setShowProfileInEvidence] = useState(false);
  const [evidenceProfiles, setEvidenceProfiles] = useState({});

  const toggleCommentUser = (willOpen, userId, isAnom = false) => {
    setShowProfileInEvidence(willOpen && isAnom);
    toggleUserModal(willOpen);
    setSelectedUserId(willOpen ? userId : '');
  };

  const deleteCom = async (_id, refetch) => {
    try {
      await client.mutate({ mutation: DELETE_COM, variables: { _id } });
    } catch (error) {
      message.error(error.message || '删除评论失败');
      return;
    }
    message.success('评论已删除');
    try {
      await refetch();
    } catch (error) {
      message.warning('评论已删除，刷新详情后可查看结果');
    }
  };

  const commentsSection = (comments, canModerate, authorId, participantIds, refetch) => {
    const positions = new Map(participantIds.map((id, index) => [id, index + 1]));
    let nextPosition = participantIds.length + (authorId && !positions.has(authorId) ? 1 : 0);
    // Older records may be missing participants. Append them without shifting saved positions.
    [...comments].reverse().forEach(({ user, isAnom }) => {
      if (isAnom && user && user._id && user._id !== authorId && !positions.has(user._id)) {
        positions.set(user._id, ++nextPosition);
      }
    });
    const displayName = comment => {
      const { user = {}, isAnom } = comment;
      const nickname = (user && user.nickname) || '未知用户';
      if (!isAnom || !user || !user._id) return nickname;
      if (user._id === authorId) return '楼主';
      return nickname + '·' + anonymousSuffix(positions.get(user._id));
    };
    const byId = new Map(comments.map(comment => [comment._id, comment]));
    const replies = new Map();
    const roots = [];
    comments.forEach(comment => {
      const rootId = comment.rootCommentId;
      if (!rootId || rootId === comment._id || !byId.has(rootId)) {
        roots.push(comment);
        return;
      }
      if (!replies.has(rootId)) replies.set(rootId, []);
      replies.get(rootId).push(comment);
    });

    const renderComment = comment => {
      const user = comment.user || {};
      const nickname = displayName(comment);
      const targetId = comment.targetCommentId || comment.rootCommentId;
      const target = byId.get(targetId);
      const hasHistory = comment.silentModerationAt || (comment.moderationHistory || []).length;
      return (
        <article className="detail-comment" key={comment._id}>
          {user._id ? (
            <button type="button" className="detail-comment-avatar"
              aria-label={`查看用户：${nickname}`}
              onClick={() => toggleCommentUser(true, user._id, comment.isAnom)}>
              <img className="message-detail-user-avatar" src={user.avatarUrl} alt="" />
            </button>
          ) : <img className="message-detail-user-avatar" src={user.avatarUrl} alt="" />}
          <div className="detail-comment-main">
            <header className="detail-comment-header">
              {user._id ? (
                <button type="button" className="detail-comment-author"
                  onClick={() => toggleCommentUser(true, user._id, comment.isAnom)}>{nickname}</button>
              ) : <strong>{nickname}</strong>}
              {authorId && user._id === authorId && !comment.isAnom && <span className="detail-comment-op">楼主</span>}
              {targetId && <span className="detail-comment-target">回复 {target ? displayName(target) : '原评论（当前未显示）'}</span>}
              {comment.deleted ? <span className="detail-comment-target">已删除</span> : comment.silentDeleted && <SilentStatus />}
            </header>
            {comment.isAnom && <EvidenceProfile profile={evidenceProfiles[user._id]} />}
            <div className="detail-comment-body">{comment.content}</div>
            {comment.imgUrl && (
              <a href={`https://cdn.zhitiaox.com/${comment.imgUrl}`} target="_blank" rel="noopener noreferrer">
                <img src={`https://cdn.zhitiaox.com/${comment.imgUrl}`} className="message-detail-img" alt="评论图片" />
              </a>
            )}
            {!!hasHistory && (
              <details className="detail-comment-history">
                <summary>处理记录</summary>
                <SilentHistory item={comment} />
              </details>
            )}
          </div>
          {canModerate && !comment.deleted && (
            <div className="detail-comment-actions">
              <SilentModeration type="comment" iconOnly ids={[comment._id]} silentDeleted={comment.silentDeleted} />
              <Popconfirm title={comment.rootCommentId ? '删除这条回复？' : '删除主评论及其所有回复？'} onConfirm={() => deleteCom(comment._id, refetch)} okText="删除" cancelText="取消">
                <Button shape="circle" type="danger" icon="delete" title="删除评论" aria-label="删除评论" />
              </Popconfirm>
            </div>
          )}
        </article>
      );
    };

    return (
      <div className="message-detail-comments">
        {roots.map(comment => (
          <div className="detail-comment-thread" key={comment._id}>
            {renderComment(comment)}
            {replies.has(comment._id) && (
              <div className="detail-comment-replies">{[...replies.get(comment._id)].reverse().map(renderComment)}</div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const UserModal = (
    <ModalBox
      visible={showUserModal}
      title={`查看用户（ID：${selectedUserId}）`}
      hideFooter
      onCancel={() => toggleCommentUser(false)}
    >
      <UserDetail key={selectedUserId} _id={selectedUserId} type="View" allowBan
        onProfileLoaded={showProfileInEvidence ? profile => {
          const { _id, nickname, avatarUrl } = profile;
          setEvidenceProfiles(previous => ({ ...previous, [_id]: { _id, nickname, avatarUrl } }));
        } : undefined}
        onViewHistory={onViewUserHistory && (() => {
          toggleCommentUser(false);
          onViewUserHistory(selectedUserId);
        })} />
    </ModalBox>
  );

  return (
    <Query query={GET_MESSAGE_DETAIL} variables={{ _id }}>
      {({ loading, error, data, refetch }) => {
        if (loading) return <Loading />;
        if (error) return <p>Error!</p>;
        if (!data.message) return <p>内容不存在</p>;
        const {
          user,
          content,
          comments,
          likeNum,
          imgUrls,
          carton,
        } = data.message;

        const thisMessage = data.message;
        const deletedCount = comments.filter(comment => comment.deleted).length;
        const { _id, nickname, avatarUrl } = user || {};
        return (
          <div className="message-detail-container">
            <header className="message-detail-header">
              <div className="message-detail-user">
                <img className="message-detail-user-avatar" src={avatarUrl} alt="" />
                <div className="message-detail-user-details">
                  <div className="message-detail-user-nickname">{nickname || '未知用户'}</div>
                  {_id && <div className="message-detail-user-id">用户 ID <code>{_id}</code></div>}
                </div>
              </div>
              {thisMessage.isAnom && <EvidenceProfile profile={evidenceProfiles[_id]} />}
              {_id && (
                <Button size="small" icon="user" onClick={() => toggleCommentUser(true, _id, thisMessage.isAnom)}>查看用户</Button>
              )}
            </header>
            <section className="message-detail-content" aria-labelledby="message-detail-content-heading">
              <div className="message-detail-content-heading">
                <div className="message-detail-content-label">
                  <h3 id="message-detail-content-heading">纸条内容</h3>
                  <span className="message-detail-post-id">纸条 ID <code>{thisMessage._id}</code></span>
                </div>
                <Query query={GET_CURRENT_USER}>
                  {({ data }) => data && data.currentUser && data.currentUser.role === 'admin' && (
                    <SilentModeration ids={[thisMessage._id]} silentDeleted={thisMessage.silentDeleted}
                      deleted={thisMessage.deleted} />
                  )}
                </Query>
              </div>
              <SilentHistory item={data.message} />
              <div className="message-detail-content-text">{content}</div>
              {/** Images */}
              {(imgUrls || {}).map(
                (imgUrl, index) =>
                  imgUrl && (
                    <a
                      href={`https://cdn.zhitiaox.com/${imgUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                    >
                      <img
                        className="message-detail-img"
                        src={`https://cdn.zhitiaox.com/${imgUrl}`}
                        alt=""
                      />
                    </a>
                  )
              )}

              {/** Carton */}
              {carton && (
                <div className="message-detail-carton">
                  <img
                    className="message-detail-carton-img"
                    src={carton.imgUrl}
                    alt=""
                  />
                  <div className="message-detail-carton-details">
                    <div className="message-detail-carton-title">
                      {carton.title}
                    </div>
                    <div className="message-detail-carton-desc">
                      {carton.desc}
                    </div>
                  </div>
                </div>
              )}
            </section>
            <section className="message-detail-discussion" aria-label="互动">
              <div className="message-detail-content-stats">
                <strong>互动</strong>
                <span>{likeNum || 0} 个赞</span>
                <span>{comments.length} 条评论{deletedCount > 0 && `（${deletedCount} 条已删除）`}</span>
              </div>
              {comments.length > 0 && (
                <Query query={GET_CURRENT_USER}>
                  {({ data }) => commentsSection(comments, !!(data && data.currentUser && data.currentUser.role === 'admin'), _id, thisMessage.anonymousParticipantIds, refetch)}
                </Query>
              )}
            </section>
            {UserModal}
          </div>
        );
      }}
    </Query>
  );
}

export default withApollo(withRouter(messageDetail));
